import type { RoomListItem } from './rooms';

/**
 * Which rooms read newest message on top (Kyu, 28 Sept 2026: "the newest
 * message always on top" in the Agents room, where Shiroe and the agents post
 * build updates).
 *
 * Only the Agents room: a channel named exactly 'Agents' (the room
 * 20270168000100 seeds and 20270174000100 makes members only, found there by
 * `is_room and name = 'Agents'`). DMs, group chats, Hub help and Team keep
 * the chat order, newest at the bottom.
 *
 * Display only. The rows already arrive newest first in the DOM (the page
 * sorts them); every other room flips them back with column-reverse
 * (.message-list in messages.css). This room drops the flip, puts the
 * composer above the list and opens at the top. Thread replies are not
 * touched: they stay oldest first under their parent.
 */
export function roomShowsNewestFirst(room: Pick<RoomListItem, 'kind' | 'name'> | null): boolean {
  return room !== null && room.kind === 'channel' && room.name === 'Agents';
}
